<template>
	<div class="container">
		<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
			<el-tab-pane label="文章" name="article">
				
			</el-tab-pane>
			<el-tab-pane label="视频" name="video">
			
			</el-tab-pane>
			<!-- <el-tab-pane label="动态" name="trends">
				
			</el-tab-pane> -->
		</el-tabs>
		<div class="create-title">
			<input maxlength="30" type="text" v-model="title" placeholder="请输入标题"/>
			<span>还可输入{{titleLength}}个字符</span>
		</div>
		<div class="editor-wrap" style="border: 1px solid #EBEBEB;" v-if="activeTab=='article'">
			<Toolbar
				style="border-bottom: 1px solid #EBEBEB"
				:editor="editor"
				:defaultConfig="toolbarConfig"
				:mode="mode"
			/>
			<Editor
				style="height: 300px; overflow-y: hidden;"
				v-model="content"
				:defaultConfig="editorConfig"
				:mode="mode"
				@onCreated="onCreated"
			/>
		</div>
		<textarea v-else-if="activeTab=='video'" v-model="content" class="content" placeholder="视频简介"></textarea>
		<textarea v-else v-model="content" class="content" placeholder="说说你的想法"></textarea>
		
		<div v-if="activeTab=='video'">
			<UploadImg @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
		</div>
		<div class="video-wrap" v-if="activeTab=='video'">
			<UploadVideo @uploadDelete="uploadDeleteVideo" @uploadSuccess="uploadSuccessVideo"/>
		</div>
		<div class="select">
			<el-form label-position="top">
				<el-form-item label="选择圈子分类">
				    <el-select filterable @change="changeCircleClassify" v-model="circleCategoryId" placeholder="请搜索或选择圈子分类">
				      <el-option v-for="(item,index) in circleClassifyList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="选择圈子">
				    <el-select filterable @change="changeCircle" v-model="circleId" placeholder="请搜索或选择圈子">
				      <el-option v-for="(item,index) in circleList" :key="index" :label="item.circleName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="帖子类型">
				    <el-select filterable  v-model="categoryId" placeholder="请搜索或选择类型">
				      <el-option v-for="(item,index) in postCategoryList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="选择话题">
				    <el-select filterable @change="changeTalkPost"  v-model="talkId" placeholder="请搜索或选择话题">
				      <el-option v-for="(item,index) in talkList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="btns">
			<a v-if="artcleId&&postType==0" @click="saveModifyPublic" href="javascript:;">保存草稿</a>
			<a v-if="!artcleId&&postType==0" @click="savePublic" href="javascript:;">保存草稿</a>
			<a v-if="postType==0" href="javascript:;" @click="viewPublic">在线预览</a>
			<a v-if="artcleId" @click="toModify" href="javascript:;" class="active">发布</a>
			<a v-else @click="toPublic" href="javascript:;" class="active">发布</a>
		</div>
	</div>
</template>

<script>
	import '@wangeditor/editor/dist/css/style.css'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	import { post, config, ajaxParam } from '@/units/request.js'
	import UploadImg from '@/components/upload/videoCover'
	import UploadVideo from '@/components/upload/video'
	import postCateModules from '@/modules/postCategory.js'
	import qs from 'qs'
	export default {
		name: 'publicIndex',
		components: {
			Editor,
			Toolbar,
			UploadImg,
			UploadVideo
		},
		mixins:[
			postCateModules
		],
		data(){
			return{
				activeTab: 'article',
				title: '',
				titleLength: 30,
				userId: '',
				picUrls: '',
				coverUrl: '', //视频封面
				postType: 0, //0文字动态1图片动态2视频动态
				categoryId: '',
				content: '',
				circleId: '',
				selectPost: '',
				postStatus: 1, // 0草稿，1发布
				circleList: [],
				artcleId: '',
				circleCategoryId:'',
				circleClassifyList: [],
				talkId:'',
				talkList: [],
				editor: null,
				html: '',
				toolbarConfig: {
					// excludeKeys: [
					// 	'insertVideo'
					// ]
				},
				editorConfig: {
					placeholder: '请输入内容...' ,
					MENU_CONF: {
						uploadImage: {
							server: config.baseUrl + "v1/upload/editorUpload",
							fieldName: "file"
						}
					}
				},
				mode: 'simple', // or 'simple'
				uploadFileUrl: []
			}
		},
		watch: {
			title(newVal){
				console.log(newVal)
				this.titleLength = 30-newVal.length
				if(this.titleLength<=0) {
					this.titleLength = 0
				}
			},
			// circleId(){
			// 	this.getPostCategory()
			// },
			uploadFileUrl(newVal, oldVal){
				console.log('变')
				if(newVal.length>0){
					this.picUrls = newVal.join(',')
					console.log(this.picUrls)
				}
			},
			$route(to, from) {
				this.activeTab = this.$route.query.type
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
			this.activeTab = this.$route.query.type || 'article'
			if(this.activeTab=='article') {
				this.postType = 0
			} else if(this.activeTab=='video') {
				this.postType = 2
			} else if(this.activeTab=='trends') {
				this.postType = 1
			}
			if(this.$route.query.id){
				this.artcleId = this.$route.query.id
				this.getDetailById()
			}else{
				this.getCircleClassify()
				
			}
			this.getTalkList()
		},
		methods: {
			//根据id获取详情，修改时用
			async getDetailById(){
				let param = {
					postId: this.artcleId,
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/postInfo', qs.stringify(param))
				if(res.data.code==200){
					let entity = res.data.entity
					console.log(entity)
					this.title = entity.postName
					this.content = entity.content
					this.circleCategoryId= entity.circleCategoryId
					this.circleId = entity.circleId
					this.talkId = entity.talkId
					this.categoryId = entity.categoryId
					this.getCircleClassify()
					this.getCircleCategory()
					this.getPostCategory()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//编辑帖子，修改时用
			async toModify(){
				let param = {
					id: this.artcleId,
					userId: this.userId,
					circleId: this.circleId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					content: this.content,
					postType: this.postType,
					categoryId: this.categoryId,
					postStatus: this.postStatus
				}
				ajaxParam(param)
				const res = await post('v1/circle/updatePost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					// this.$message.success('修改发布成功!')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//保存草稿修改
			async saveModifyPublic(){
				this.postStatus = 0
				let param = {
					id: this.artcleId,
					userId: this.userId,
					circleId: this.circleId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					content: this.content,
					postType: this.postType,
					categoryId: this.categoryId,
					postStatus: this.postStatus
				}
				ajaxParam(param)
				const res = await post('v1/circle/updatePost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					// this.$message.success('修改草稿成功!')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
			uploadSuccessVideo(e){
				console.log(e)
				console.log(e.videoUrl)
				this.picUrls = e.videoUrl
				console.log(this.picUrls)
			},
			uploadDeleteVideo(e){
				
			},
			uploadSuccess(e){
				console.log('success')
				console.log(e.uploadFileList)
				this.coverUrl = e.uploadFileList[0]
			},
			uploadDelete(e){
				console.log('delete')
				console.log(e.uploadFileList)
				this.coverUrl = ''
			},
			changeCircleClassify(e){
				console.log(e)
				this.circleCategoryId = e
				this.circleId = ''
				this.categoryId = ''
				this.postCategoryList = []
				this.circleList = []
				this.getCircleCategory()
			},
			changeCircle(e){
				console.log(e)
				this.circleId = e
				this.categoryId = ''
				this.getPostCategory()
			},
			changeTalkPost(e){
				this.talkId = e
				console.log(e)
			},
			//获取圈子父级分类
			async getCircleClassify(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleCategory', qs.stringify(param))
				if(res.data.code==200){
					this.circleClassifyList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取加入圈子分类
			async getCircleCategory(){
				let param = {
					userId: this.userId,
					categoryId:this.circleCategoryId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleList', qs.stringify(param))
				if(res.data.code==200){
					this.circleList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取加入圈子话题
			async getTalkList(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/circle/circlePostTalk', qs.stringify(param))
				if(res.data.code==200){
					this.talkList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//保存草稿
			savePublic(){
				this.postStatus = 0
				if(!this.title&&(!this.content||this.content=='<p><br></p>')){
					this.$message.error('请至少填写一处才能保存')
					return
				}
				this.public()
			},
			//在线预览
			async viewPublic(){
				if(!this.title&&(!this.content||this.content=='<p><br></p>')){
					this.$message.error('请至少填写一处才能保存')
					return
				}
				this.postStatus = 0
					
					let param = {
						postName: this.title,
						picUrls: this.picUrls,
						content: this.content
					}
					if(this.talkId){
						const talkItem = this.talkList.filter(item=>{return item.id==this.talkId})
						if(talkItem.length>0){
							const talkName = talkItem[0].categoryName
							param.talkName = talkName
						}
					}
					localStorage.setItem('previewInfo',JSON.stringify(param))
					window.open('/detail?id=')
				
			},
			toPublic(){
				this.postStatus = 1
				if(!this.title) {
					this.$message.error('请输入文章标题')
					return
				}
				if(!this.content||this.content=='<p><br></p>') {
					this.$message.error('请输入发布内容')
					return
				}
				if(!this.circleId) {
					this.$message.error('请选择圈子')
					return
				}
				// if(!this.categoryId) {
				// 	this.$message.error('请选择话题')
				// 	return
				// }
				this.public()
			},
			//发布
			async public(){
				let param = {
					userId: this.userId,
					circleId: this.circleId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					coverUrl: this.coverUrl,
					content: this.content,
					postType: this.postType,
					categoryId: this.categoryId,
					postStatus: this.postStatus
				}
				console.log(param)
				ajaxParam(param)
				const res = await post('v1/circle/addPost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					if(this.postStatus==1){
						this.$router.push({
							path: '/publicManage'
						})
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			//上传视频前验证
			beforeUpload(file){
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['mp4', 'avi']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("请上传正确的视频格式")
					return false
				}
			},
			//上传附件成功
			handleSuccess(res){
				console.log(res)
				window.alert('--------')
			},
			resetForm(){
				this.title = ''
				this.content = ''

				this.circleCategoryId = ''
				this.circleId = ''
				this.categoryId = ''
				this.talkId = ''

				this.picUrls = ''
				this.coverUrl = ''
			},
			handleClick(tab,e){
				this.activeTab = tab.name
				this.content= ''
				if(tab.name=='video'){
					this.postType = 2
				} else if(tab.name=='trends'){
					this.postType = 1
				} else{
					this.postType = 0
				}
				this.resetForm()
			}
		}
	}
</script>

<style lang="less" scoped>
::v-deep .el-form--label-top .el-form-item__label{
	padding:0;
}
	.container{
		.create-title{
			display: flex;
			align-items: center;
			margin: 22px 0 15px;
			input{
				width: 312px;
				height: 22px;
				padding: 5px 10px;
				border: 1px solid #EBEBEB;
			}
			span{
				margin-left: 10px;
				font-size: 12px;
				color: #4a4a4a;
			}
		}
		.editor-wrap{
			margin-bottom: 20px;
			z-index: 999999;
			// ::v-deep{
			// 	h1, h2, h3, h4, h5, h6{
			// 	font-size: inherit;
			// 	font-weight: inherit;
				
			// }
			// }
		}
		.content{
			width: 60%;
			height: 160px;
			margin-bottom: 15px;
			padding: 10px;
			border-color: #DBDCDC;
			box-sizing: border-box;
			border-radius: 4px;
		}
		.select{
			.el-form{
				display: flex;
				justify-content: space-between;
				.el-form-item{
					flex: 1;
					/deep/ .el-form-item__content{
						line-height: 30px;
					}
					/deep/ .el-input__inner{
						height: 30px;
						line-height: 30px;
					}
					/deep/ .el-input__icon{
						line-height: 30px;
					}
				}
				
			}
		}
		.btns{
			display: flex;
			justify-content: flex-end;
			margin-top: 20px;
			a{
				display: block;
				width: 88px;
				height: 34px;
				margin-left: 15px;
				background: rgba(50,50,50,.1);
				border-radius: 16px;
				line-height: 34px;
				text-align: center;
			}
			a:hover, a.active{
				background: #CF171D;
				color: #fff;
			}
		}
		.video-wrap{
			margin-bottom: 20px;
			// display: flex;
			// justify-content: center;
			// padding: 50px 0;
		}
		.trends{
			
		}
		.empty{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 260px;
			margin: 60px auto;
			img{
				width: 260px;
				height: 230px;
			}
			span{
				padding: 20px 0 30px;
				color: var(--color-text-opacity);
			}
			.public-btn{
				display: block;
				width: 88px;
				height: 34px;
				background: #CF171D;
				border-radius: 16px;
				line-height: 34px;
				text-align: center;
				color: #fff;
			}
		}
	}
</style>
